<template>
  <div class="aw-ic-center">
    <div class="com-sub-top">
      <div class="title container-center">智算中心解决方案</div>
    </div>
    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">产品概述</p>
        <p class="desc">
          海云捷迅为企业及政府机构提供算力数据中心建设解决方案，提供定制化的算力数据中心建设和改造服务，用于提供大规模计算资源的数据中心。解决方案中拥有高性能的服务器、存储系统和网络设备，能够处理大量的数据和复杂的计算任务。
        </p>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center">
        <p class="title">智算中心服务类型</p>
        <ul class="com-scene-desc com-scene-desc-speci">
          <li>
            <img src="@/assets/aiCenter/aiCenter_img_1_1@2x.png" alt="" />
            <p class="desc">数智产业园模式</p>
            <p class="scene-desc">
              以数智产业园为核心，打造集算力中心、行业云平台、产学研创新基地等多功能于一体的数字经济示范项目。产业园模式通过吸引数字经济相关产业链，带动产业发展和创新，为用户、地区政府提供更丰富的上下游业务场景和合作机会。
            </p>
          </li>
          <li>
            <img src="@/assets/aiCenter/aiCenter_img_1_2@2x.png" alt="" />
            <p class="desc">算力交易平台</p>
            <p class="scene-desc">海云捷迅算力交易平台支持算力资源的交易、共享和撮合。允许用户根据自己的需求购买或租赁算力资源，提高供给方算力资源的利用率和需求方算力使用的灵活性，降低算力闲置成本和使用成本。</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">海云捷迅的服务内容</p>
        <div class="service-content">
            <div class="m-sc-box">
                <ul class="sc-list">
                    <li @click="choose('1')" :class="{active : key == '1'}">
                        <span class="circle"></span>
                        <span >基础设施建设</span>
                    </li>
                    <li @click="choose('2')" :class="{active : key == '2'}">
                        <span class="circle"></span>
                        <span >算力配置提供</span>
                    </li>
                    <li @click="choose('3')" :class="{active : key == '3'}">
                        <span class="circle"></span>
                        <span >网络架构搭建</span>
                    </li>
                    <li @click="choose('4')" :class="{active : key == '4'}">
                        <span class="circle"></span>
                        <span >管理与服务</span>
                    </li>
                </ul>
            </div>
            <div>
                <div v-if="key == '1'">
                    <p class="service-title">制冷布局</p>
                    <p class="service-desc">根据数据中心的实际发热量和环境要求，定制高效的制冷系统。可选择风冷、水冷、液冷等不同的制冷方式，或者采用混合制冷模式，以提高制冷效率和降低能耗。对于高性能计算场景，液冷技术能够更有效地为高功率密度的算力设备散热，保障设备的稳定运行。</p>

                    <p class="service-title">电力系统定制</p>
                    <p class="service-desc" style="margin-bottom: 0">提供高可靠性的电力解决方案，可根据客户的算力设备需求和业务运行特点，定制不同容量的电力供应系统。支持双路供电或多路供电模式，配备冗余的不间断电源（UPS）和备用柴油发电机，确保在市电故障时能够持续稳定地为算力设备供电。</p>
                </div>

                <div v-if="key == '2'">
                    <p class="service-desc">根据客户的业务类型（如云计算、大数据分析、人工智能等）的算力要求，定制通用服务器、超算服务器、智算服务器的配置。云计算业务配置具有高内存容量和多核心处理器的服务器，以满足多用户同时访问和资源分配的需求；对于超算业务配置具有高速并行运算能力的GPU服务器；对于人工智能业务配置具有强大张量处理能力和高通讯带宽的GPU服务器。</p>

                    <p class="service-desc" style="margin-bottom: 0">根据业务需要支持服务器的灵活扩展，无论是在机柜内增加服务器数量，还是在整个数据中心内进行服务器集群的扩展。服务器采用标准化的接口和架构，方便客户进行设备的更新和升级。</p>
                </div>

                <div v-if="key == '3'">
                    <p class="service-title">高速网络连接</p>
                    <p class="service-desc">构建高带宽、低延迟的网络架构，确保算力数据的快速传输和处理。采用先进的以太网技术或光通信技术，提供高速的网络接口，满足用户对大规模数据传输和实时性要求较高的业务需求。</p>

                    <p class="service-title">网络冗余与安全</p>
                    <p class="service-desc" style="margin-bottom: 0">提供网络冗余设计，包括冗余的网络设备、链路备份等，保障网络的可靠性和可用性。同时，加强网络安全防护，部署防火墙、入侵检测系统、数据加密等安全措施，保护客户的数据和业务安全。</p>
                </div>

                <div v-if="key == '4'">
                    <p class="service-title">运维管理</p>
                    <p class="service-desc">提供 7×24 小时的专业运维团队服务，包括服务器的监控、维护、故障排除等。运维人员可以通过先进的监控系统，实时掌握服务器的运行状态、性能指标等信息。例如，当服务器的 CPU 使用率过高或者内存出现故障时，运维人员能够及时收到警报并采取相应的措施。定期对数据中心的设备进行维护和保养，如对空调系统的滤网清洗、服务器的硬件检查等。并且，会根据设备的运行情况和使用寿命，提前规划设备的更新和替换，确保数据中心始终保持良好的运行状态。</p>

                    <p class="service-title">定制化服务</p>
                    <p class="service-desc" style="margin-bottom: 0">根据客户的特殊需求，如特定的安全标准、合规要求等提供定制化服务。</p>
                </div>
            </div>
        </div>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">海云捷迅算力中心特点</p>
        <ul class="com-product-card">
          <li>
            <div class="title-box">
              <img src="@/assets/aiCenter/aiCenter_icon_2_1@2x.png" alt="" />
              <h5>人工智能和机器学习</h5>
            </div>
            <p class="desc">提供训练和推理所需的大规模计算能力，尤其是在大模型、深度学习领域。</p>
          </li>
          <li>
            <div class="title-box">
              <img src="@/assets/aiCenter/aiCenter_icon_2_2@2x.png" alt="" />
              <h5>高性能计算（HPC）</h5>
            </div>
            <p class="desc">
              用于科学研究和工程计算，如气象模拟、物理实验模拟、基因测序、药物研发等。
            </p>
          </li>
          <li style="margin-right: 0;">
            <div class="title-box">
              <img src="@/assets/aiCenter/aiCenter_icon_2_3@2x.png" alt="" />
              <h5>云计算</h5>
            </div>
            <p class="desc">提供虚拟化的计算资源，包括服务器、存储和数据库服务，用户可以根据需要动态扩展或缩减资源。</p>
          </li>
          <li>
            <div class="title-box">
              <img src="@/assets/aiCenter/aiCenter_icon_2_4@2x.png" alt="" />
              <h5>大数据分析</h5>
            </div>
            <p class="desc">处理和分析海量数据，支持数据挖掘、机器学习和人工智能应用。</p>
          </li>
          <li>
            <div class="title-box">
              <img src="@/assets/aiCenter/aiCenter_icon_2_5@2x.png" alt="" />
              <h5>内容分发网络（CDN）</h5>
            </div>
            <p class="desc">快速分发内容到用户，需要强大的计算能力来处理路由优化、数据压缩和缓存策略。</p>
          </li>
        </ul>
      </div>
    </div>    
  </div>
</template>
<script>
export default {
    data() {
        return {
            key: "1"
        }
    },
    methods: {
        choose(val) {
            this.key = val;
        },
    }
}
</script>